export default __webpack_public_path__ + "static/media/commercialCard.76d5bd6a.png";